import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    bankStatements: {
      sectionTitle: 'Bank statements',
      title: 'Access bank statements',
    },
    currentExports: {
      sectionTitle: 'My scheduled exports',
    },
    description: 'Export your transactions and receipts for a given period.',
    newExport: {
      monthly: {
        title: 'Schedule a monthly export',
      },
      oneTime: {
        title: 'Generate a single export',
      },
      sectionTitle: 'New export',
    },
    title: 'Export of accounting data',
  },
  fr: {
    bankStatements: {
      sectionTitle: 'Relevés bancaires',
      title: 'Accéder aux relevés bancaires',
    },
    currentExports: {
      sectionTitle: 'Mes exports automatisés',
    },
    description:
      'Exportez vos transactions et vos reçus pour une période donnée.',
    newExport: {
      monthly: {
        title: 'Planifier un export mensuel',
      },
      oneTime: {
        title: 'Générer un export ponctuel',
      },
      sectionTitle: 'Nouvel export',
    },
    title: 'Export comptable',
  },
} as const);

export default locales;
